var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameIconsStreetLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m262.5 33l-10 30h87l-10-30zM160 39c-26 0-45.2 9.12-56.9 23.24C91.32 76.35 87 94.5 87 112v263h18V112c0-14.5 3.7-28.35 11.9-38.24C125.2 63.88 138 57 160 57h75.5l6-18zm79.3 42l-43.7 42.5l41.9-19.1l-34.5 86.9l62.6-58.3l-1.1 91.7l31.8-101.2l70.5 117.6l-31.3-130.9l61.5 36.1L349.5 81zM72.55 393l-5.08 100h57.03l-5.1-100z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIconsStreetLight);
export default __webpack_public_path__ + "static/media/game-icons--street-light.8874a482d0034de31ac3b2764d1b197c.svg";
export { ForwardRef as ReactComponent };